

module.config(function($stateProvider) {
      $stateProvider.state('settings.americorps', {
        url: '/americorps',
        templateUrl: 'settings/americorps',
        permission: 'editGrantYears',
        resolve: {
            urlBuilder: function(ApiUrl) {
                return ApiUrl.partial('initiatives', 'americorps', 'grant-year');
            },
            grantYears: function($http, urlBuilder) {
                return $http.get(urlBuilder()).then(function (response) {
                    return response.data.grant_years;
                });
            },
        },

        controller: module.cC({
            inject: ['$scope', '$http', 'grantYears', 'moment', 'urlBuilder',
                     'Notifications', 'BasicOptions'],
            data: {
                grantYears: 'grantYears',
                newGrantYear: 'false',
                amcHourTypes: 'BasicOptions.amcHourTypes',
            },
            methods: {
                openNewForm: function() {
                    this.$.newGrantYear = {year: this.moment().year()};
                },

                closeNewForm: function() {
                    this.$.newGrantYear = false;
                },

                openEditForm: function(grantYear) {
                    this.editing = grantYear;
                    this.$.editGrantYear = angular.copy(grantYear);
                },

                closeEditForm: function() {
                    delete this.editing;
                    delete this.$.editGrantYear;
                },

                saveNewGrantYear: function(form, data) {
                    if (!form.$valid || form.$pending) return;

                    this.$http.post(this.urlBuilder(), data).then(
                        this._saveNewGrantSuccess,
                        this._saveNewGrantError
                    );
                },

                saveEditForm: function(form, data) {
                    if (!form.$valid) return;

                    this.$http.put(this.urlBuilder(data.year), data).then(
                        this._editGrantSuccess,
                        this._editGrantError);
                },

                _saveNewGrantSuccess: function(response) {
                    this.grantYears.push(response.data.grant_year);
                    this.closeNewForm();
                },

                _saveNewGrantError: function(response) {
                    if (response.status === 400) {
                        this.Notifications.error(response.data.message);
                    } else {
                        this.Notifications.canned('form_errors');
                    }
                },

                _editGrantSuccess: function(response) {
                    angular.copy(response.data.grant_year, this.editing);
                    this.closeEditForm();
                },

                _editGrantError: function(response) {
                    this.Notifications.canned('form_errors');
                },
            }
        }),
    });
});

